import React from 'react';
import { EmployeeFormWrapper } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormWrapper/EmployeeFormWrapper';
import { EmployeeFormProps } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';
import { EmployeeFormFooter } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormFooter/EmployeeFormFooter';
import { EmployeeInformation } from 'src/components/enterprise/features/Employee/components/Form/EmployeeInformation/EmployeeInformation';
import { EmployeePermissions } from 'src/components/enterprise/features/Employee/components/Form/EmployeePermissions/EmployeePermissions';

export const EmployeeForm: React.FC<EmployeeFormProps> = ({
  defaultValues,
  onSubmit,
}) => {
  return (
    <EmployeeFormWrapper defaultValues={defaultValues}>
      <EmployeeInformation />
      <EmployeePermissions />
      <EmployeeFormFooter onSubmit={onSubmit} />
    </EmployeeFormWrapper>
  );
};
